export const WarehousesTableColumns = [
    { id: "name",        labelEn: "Name",     labelAr: "الاسم",      align: "left",   sortable: true },
    { id: "is_default",  labelEn: "Default",  labelAr: "افتراضي",    align: "center", sortable: false },
    { id: "created_at",  labelEn: "Created",  labelAr: "تاريخ الإنشاء", align: "center", sortable: true },
];
